// useAuthRedirect.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useAuthRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const originalPath = localStorage.getItem("originalPath");
    console.log("hook called");
    if (originalPath) {
      localStorage.removeItem("originalPath");
      navigate(originalPath, { replace: true });
    }
  }, [navigate]);
};
